import { render, staticRenderFns } from "./WarehouseView.vue?vue&type=template&id=f4d4be0c&scoped=true&"
import script from "./WarehouseView.vue?vue&type=script&lang=js&"
export * from "./WarehouseView.vue?vue&type=script&lang=js&"
import style0 from "./WarehouseView.vue?vue&type=style&index=0&id=f4d4be0c&prod&lang=css&"
import style1 from "./WarehouseView.vue?vue&type=style&index=1&id=f4d4be0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4d4be0c",
  null
  
)

export default component.exports